module.exports = __webpack_public_path__ + "static/flags/VI-a8f551b77716f0e5e915ebd14cbe415f.gif";